import React from 'react';
import {
  ListProps,
  TextField,
  DateField,
  FunctionField,
  useRedirect,
} from 'react-admin';

import {
  TextInput,
  Grid,
  GridList,
  Forbidden,
  PhoneField,
  EmailField,
  BooleanField,
  FileField,
  JsonField,
} from '@components';
import { useRbacList } from '@hooks';
import { Register } from '@types';
import cls from './RegisterList.module.css';

export const RegisterList = (props: ListProps) => {
  const redirect = useRedirect();
  const rbacList = useRbacList();

  if (!rbacList) {
    return <Forbidden />;
  }

  return (
    <GridList {...props}
      filters={Filters}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Grid
        rowClick="edit"
        defaultColumns={[
          'activeStepEn', 'phone', 'email', 'companyName', 'globalResult',
          'globalResultDescription', 'globalError', 'createdAt',
        ]}
      >
        <TextField source="id" label="ID" />
        <TextField source="statusEn" label="Status" />
        <TextField source="activeStepEn" label="Active step" />
        <TextField source="globalResult" label="WeeTrust Result" />
        <TextField source="globalResultDescription" label="WeeTrust Description" />
        <TextField source="globalError" label="WeeTrust API Error" />
        <TextField source="weetrustAttempts" label="WeeTrust API attempts" />
        <TextField source="weetrustSeconds" label="WeeTrust API seconds" />
        <PhoneField source="phone" label="Phone" />
        <EmailField source="email" label="Email" wrap />
        <TextField source="gender" label="Gender" />
        <TextField source="marriage" label="Civil status" />
        <TextField source="companyName" label="Company" />
        <BooleanField source="isCompany" label="Is Company" />
        <DateField source="createdAt" label="Registration Date" showTime />
        <DateField source="updatedAt" label="Updated At" showTime />
        <FunctionField source="user.code" label="User Code" render={(record: Register) => {
          if (!record.user) return null;
          return <span
            className={cls.link}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              redirect(`/user/${record.user?.id}?initial`);
            }}
          >{record.user.code}</span>;
        }} />
        <FunctionField source="user.fullName" label="User Name" render={(record: Register) => {
          if (!record.user) return null;
          return <span
            className={cls.link}
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              redirect(`/user/${record.user?.id}?initial`);
            }}
          >{record.user.fullName}</span>;
        }} />

        <BooleanField source="isManual" label="Is Manual" />
        <FileField source="fileFront" label="Doc INE-front" forList />
        <FileField source="fileBack" label="Doc INE-back" forList />
        <FileField source="fileFace" label="Doc INE-face" forList />
        <TextField source="ip" label="IP Address" />
        <JsonField source="headers" label="HTTP Headers" />
        <JsonField source="weetrustRequest" label="WeeTrust upload Request" />
        <JsonField source="weetrustResponse" label="WeeTrust upload Response" />
        <JsonField source="weetrustError" label="WeeTrust upload Error" />
        <DateField source="weetrustAt" label="WeeTrust upload At" showTime />
        <TextField source="weetrustUuid" label="WeeTrust upload UUID" />
        <JsonField source="weetrustResultRequest" label="WeeTrust result Request" />
        <JsonField source="weetrustResultResponse" label="WeeTrust result Response" />
        <JsonField source="weetrustResultError" label="WeeTrust result Error" />
        <DateField source="weetrustResultAt" label="WeeTrust result At" />
        <JsonField source="weetrustVerification" label="WeeTrust verification" />
      </Grid>
    </GridList>
  );
};

const Filters = [
  <TextInput source="q" key="q" label="Search" alwaysOn style={{ width: 220 }} />,
];
